import React from 'react';
import { Player, GameState } from '../../../domain/entities';
import { getPlayerValue } from '../../../domain/constants';

interface PlayerContractPanelProps {
    player: Player;
    leagueName: string;
    gameState: GameState;
}

export const PlayerContractPanel: React.FC<PlayerContractPanelProps> = ({ player, leagueName, gameState }) => {
    return (
        <div className="panel">
            <div className="panel-header">Contract</div>
            <div className="panel-content">
                <div className="player-detail-contract-item">
                    <span className="player-detail-contract-label">Market Value</span>
                    <span className="player-detail-contract-value highlight">£{getPlayerValue(player, leagueName, gameState.gameType, gameState.config).toLocaleString()}</span>
                </div>
                <div className="player-detail-contract-item">
                    <span className="player-detail-contract-label">Weekly Wage</span>
                    <span className="player-detail-contract-value">£{player.wage.toLocaleString()}</span>
                </div>
                <div className="player-detail-contract-item">
                    <span className="player-detail-contract-label">Years Remaining</span>
                    <span className="player-detail-contract-value">{player.contract.yearsRemaining}</span>
                </div>
                <div className="player-detail-contract-item">
                    <span className="player-detail-contract-label">Expires At</span>
                    <span className="player-detail-contract-value">Season {player.contract.expirySeason}</span>
                </div>
            </div>
        </div>
    );
};
